// removed by extract-text-webpack-plugin
module.exports = {"label":"index__label___1BkqV","checkbox":"index__checkbox___1-8M_","small":"index__small___1btrb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Checkbox/index.css
// module id = 1000
// module chunks = 37